import React from "react";
import { Chat } from "../../../types/conversations";
import { formatLastSeen } from "../../../helpers/conversations";

interface UserInfoProps {
  chat: Chat;
  isStudent: boolean;
  onClick: () => void;
}

const StatusText: React.FC<{ chat: Chat }> = ({ chat }) => {
  if (chat.online) {
    return (
      <span className="text-green-600 dark:text-green-400 font-medium">
        Online
      </span>
    );
  }
  if (
    chat.lastSeen &&
    formatLastSeen(new Date(chat.lastSeen)) !== "nunca visto"
  ) {
    return (
      <span className="text-gray-500 dark:text-gray-400">
        Visto {formatLastSeen(chat.lastSeen)}
      </span>
    );
  }
  return null;
};

export const UserInfo: React.FC<UserInfoProps> = ({
  chat,
  isStudent,
  onClick,
}) => (
  <div
    className="flex-1 min-w-0 cursor-pointer group"
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
  >
    <div className="flex flex-col gap-0.5 md:flex-row md:items-center md:gap-2">
      <h2 className="font-semibold text-base text-gray-900 dark:text-white truncate group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors md:text-[15px]">
        {chat.name}
      </h2>
      <div className="flex flex-shrink-0 md:contents">
        {isStudent && (
          <span
            className="inline-flex w-fit text-xs rounded bg-blue-500/90 text-white text-[10px] font-medium px-1.5 py-0.5 md:text-xs md:px-2"
            title="Aluno vinculado ao profissional"
          >
            Aluno
          </span>
        )}
        {!isStudent && (
          <span
            className="inline-flex w-fit rounded bg-yellow-500/90 text-white text-[10px] font-medium px-1.5 py-0.5 md:text-xs md:px-2"
            title="Interessado no profissional"
          >
            Interessado
          </span>
        )}
      </div>
    </div>
    <p className="text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5">
      <StatusText chat={chat} />
    </p>
  </div>
);
